import { atom, signal } from "kho";
import type { Camera, Scene, WebGLRenderer } from "three";

/**
 * Bridge atoms — the imperative Viewer OWNS the three.js renderer/camera/scene
 * and the render loop; it publishes them here so kho editor systems can react.
 * This mirrors poc/editor's data/scene.ts, but in the POC these are owned by
 * rendererSystem/cameraSystem — here they are fed in by the Viewer bridge
 * (see editorStore.ts) because the client's viewer is imperative.
 */
export const $scene = atom<Scene | null>(null);
export const $camera = atom<Camera | null>(null);
export const $renderer = atom<WebGLRenderer | null>(null);

/** Ticked once per render by the bridge — systems do per-frame work here. */
export const $frame = signal<{ dt: number; time: number }>();
